import React, { useEffect, useState } from "react";
import performRequest from "../../../api/request";
import { useLocation, useNavigate } from "react-router";
import LoadingPage from "../../../Components/layouts/loading";
import { extractDate } from "../../../Components/Functions/date.fun";
import { Toast } from "../../../CustomComponent/toast";
import { FcFeedback } from "react-icons/fc";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";

const Emailmarketing = () => {
  const navigate = useNavigate();
  const [templateData, setTemplateData] = useState([]);
  const [templateName, setTemplateName] = useState("");
  const [loading, setLoading] = useState(true);
  const [previousData, setPreviousData] = useState([]);
  const [updateData, setUpdateData] = useState({});
  const [minDate, setMinDate] = useState("");
  const [date, setDate] = useState("");
  const [error, setError] = useState("");
  const [disabledDates, setDisabledDates] = useState([]);
  const location = useLocation();

  useEffect(() => {
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);
    const formattedTomorrow = tomorrow.toISOString().split("T")[0];
    setMinDate(formattedTomorrow);
  }, []);
  const isDateDisabled = (inputDate) => {
    return disabledDates.includes(inputDate);
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!date) {
      setError("Please select a date.");
    } else if (date < minDate) {
      setError("You cannot select a past date.");
    } else {
      setError("");
      performRequest("POST", `/emailSchedule/create-emailMarketingSchedule/`, {
        scheduleDate: date,
        templateName,
      })
        .then((res) => {
          if (res.status === 201) {
            Toast("success", "Email Delivery Schedule Successfully");
          }
        })
        .catch((err) => {
          Toast("error", err.response.data.flag);
          console.error(err);
        });
    }
  };

  const getTemplateScheduleData = (templatename) => {
    performRequest(
      "GET",
      `/emailSchedule/emailMarketingSchedule/${templatename}`
    )
      .then((res) => {
        if (res.status === 200) {
          setPreviousData(res.data);
          let dateData = res.data.map((el) => {
            return el.scheduleDate;
          });
          setDisabledDates(dateData);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };
  const handleUpdateScheduleData = (e) => {
    e.preventDefault();
    performRequest(
      "PATCH",
      `/emailSchedule/update-emailMarketingSchedule/${updateData?.id}`,
      { scheduleDate: date, templateName }
    )
      .then((res) => {
        if (res.status === 200) {
          Toast("success", "Email Delivery Schedule Updated Successfully");
        }
      })
      .catch((err) => {
        Toast("error", err.response.data.flag);
        console.error(err);
      });
  };

  const handleDeleteSchedule = (id) => {
    performRequest(
      "DELETE",
      `/emailSchedule/delete-emailMarketingSchedule/${id}`
    )
      .then((res) => {
        if (res.status === 200) {
          let btn = document.getElementById("schedule-delete-close");
          btn.click();
          Toast("success", "Schedule deleted successfully");
        }
      })
      .catch((err) => {
        Toast("error", err.response.data.flag);
        console.error(err);
      });
  };
  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/bulkemail/get-all-email-template/`)
      .then((res) => {
        if (res.status === 200) {
          setTemplateData(res.data.allTemplates);
        }
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => setLoading(false));
  }, []);

  const handleToggleStatus = async (item) => {
    try {
      const values = {
        isActive: !item.isActive,
      };

      // Update UI instantly (Optimistic Update)
      setTemplateData((prev) =>
        prev.map((el) =>
          el.id === item.id ? { ...el, isActive: !el.isActive } : el
        )
      );

      const res = await performRequest(
        "PATCH",
        `/bulkemail/changeEmailTemplateActiveness/${item?.id}`,
        values
      );

      if (res.status === 200) {
        Toast(
          "success",
          `Template ${
            values.isActive ? "Activated" : "Deactivated"
          } Successfully`
        );
      }
    } catch (err) {
      // Revert UI if API fails
      setTemplateData((prev) =>
        prev.map((el) =>
          el.id === item.id ? { ...el, isActive: item.isActive } : el
        )
      );

      CustomErrorResponse(err);
    }
  };

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-body">
            <div className="row col-12">
              <div className="col-md-8">
                <h2 className="page-title mb-1">
                  <FcFeedback className="fs-2  me-1" /> Email Marketing
                </h2>
                <h4 className="text-muted">
                  Plan and send your emails to clients.
                </h4>
              </div>

              <div className="card">
                <div className="card-body p-2">
                  <div className="card-title p-2 d-flex justify-content-between">
                    <h2>Templates</h2>
                    <div className="text-end">
                      <button
                        className="btn btn-primary"
                        onClick={() =>
                          navigate(`/create-email-template${location?.search}`)
                        }
                      >
                        CREATE EMAIL TEMPLATE
                      </button>
                    </div>
                  </div>

                  <div class="row row-cards">
                    <div class="col-12">
                      <div class="card">
                        <div class="card-body card-body-scrollable card-body-scrollable-shadow">
                          <div class="divide-y">
                            <div>
                              {templateData &&
                                templateData.length > 0 &&
                                templateData.map((el, index) => {
                                  return (
                                    <div class="row mb-1" key={index}>
                                      <div class="col-auto">
                                        <span class="avatar">
                                          {`${el?.templateName[0]} ${
                                            el?.templateName[
                                              el?.templateName.length - 1
                                            ]
                                          }`}
                                        </span>
                                      </div>
                                      <div class="col">
                                        <div class="text-truncate">
                                          <strong>{el?.templateName}</strong>
                                        </div>
                                        <div class="text-secondary">
                                          Subject :{" "}
                                          <span> {el?.subjectPart}</span>
                                        </div>
                                        <div class="text-secondary">
                                          Created :{" "}
                                          <span>
                                            {" "}
                                            {extractDate(el?.timeStamp)}
                                          </span>
                                        </div>
                                      </div>
                                      <div class="col-auto align-self-center">
                                        <div class="d-flex align-items-center gap-2 flex-wrap">
                                          <div className="form-check form-switch m-0">
                                            <input
                                              className="form-check-input"
                                              type="checkbox"
                                              checked={el?.isActive}
                                              disabled={loading}
                                              onChange={() =>
                                                handleToggleStatus(el)
                                              }
                                              style={{
                                                backgroundColor: el?.isActive
                                                  ? "green"
                                                  : "red",
                                              }}
                                            />
                                          </div>

                                          <a
                                            href="#"
                                            class="btn btn-secondary me-2"
                                            onClick={() => {
                                              return (
                                                setTemplateName(
                                                  el?.templateName
                                                ),
                                                getTemplateScheduleData(
                                                  el?.templateName
                                                )
                                              );
                                            }}
                                            data-bs-toggle="modal"
                                            data-bs-target="#modal-report"
                                          >
                                            Schedule send mail
                                          </a>

                                          <button
                                            className="btn btn-secondary me-2"
                                            onClick={() =>
                                              navigate(
                                                `/send-bulk-email/${el?.templateName}${location?.search}`
                                              )
                                            }
                                          >
                                            send mail
                                          </button>

                                          <button
                                            className="btn btn-secondary"
                                            onClick={() =>
                                              navigate(
                                                `/edit-email-template/${el?.templateName}${location?.search}`
                                              )
                                            }
                                          >
                                            Edit template
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  );
                                })}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Schedule Mail  */}
      <div
        className="modal modal-blur fade"
        id="modal-report"
        tabIndex="-1"
        style={{ display: "none" }}
        aria-hidden="true"
      >
        <div
          className="modal-dialog modal-lg modal-dialog-centered"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Schedule Email Sending Date</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                id="schedule-delete-close"
              ></button>
            </div>

            <div className="modal-body">
              <form className="form-control " onSubmit={handleSubmit}>
                <div className="row">
                  <div
                    className="col-lg-7 overflow-auto"
                    style={{ maxHeight: "250px" }}
                  >
                    <h3>Scheduled Date List</h3>
                    {previousData && previousData.length > 0 ? (
                      previousData.map((el, index) => (
                        <div
                          key={index}
                          className="card mb-3 scheduled-date-card"
                        >
                          <div className="card-body d-flex justify-content-between align-items-center">
                            <span className="scheduled-date">
                              <strong> Scheduled Date:</strong>{" "}
                              {el.scheduleDate}
                            </span>
                            <button
                              type="button"
                              className="btn btn-primary btn-sm edit-btn"
                              data-bs-toggle="modal"
                              data-bs-target="#modal-report-edit"
                              onClick={() => {
                                setUpdateData({
                                  templateName: el.templateName,
                                  scheduleDate: el.scheduleDate,
                                  id: el.id,
                                });
                              }}
                            >
                              Edit
                            </button>
                            <button
                              className="btn btn-danger btn-sm delete-btn"
                              type="button"
                              onClick={() => {
                                handleDeleteSchedule(el.id);
                              }}
                            >
                              Delete
                            </button>
                          </div>
                        </div>
                      ))
                    ) : (
                      <p>No scheduled dates available.</p>
                    )}
                  </div>
                  <div className="col-lg-5">
                    <div className="">
                      <div className="mb-3">
                        <label className="form-label">Template Name</label>
                        <input
                          type="text"
                          className="form-control"
                          value={templateName}
                          onChange={(e) => setTemplateName(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="">
                      <div className="mb-3">
                        <label className="form-label">Schedule Date</label>
                        <input
                          type="date"
                          required
                          className={`form-control ${
                            error ? "is-invalid" : ""
                          }`}
                          min={minDate}
                          value={date}
                          onChange={(e) => {
                            const selectedDate = e.target.value;
                            if (isDateDisabled(selectedDate)) {
                              setError(
                                "This date is not available for selection."
                              );
                            } else {
                              setError(""); // Clear the error if the date is valid
                            }
                            setDate(selectedDate);
                          }}
                        />
                        {error && (
                          <div className="invalid-feedback">{error}</div>
                        )}
                      </div>
                    </div>
                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-secondary"
                        data-bs-dismiss="modal"
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className="btn btn-primary ms-auto"
                        data-bs-dismiss="modal"
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* Edit Schedule */}

      <div
        className="modal modal-blur fade"
        id="modal-report-edit"
        tabIndex="-1"
        style={{ display: "none" }}
        aria-hidden="true"
      >
        <div
          className="modal-dialog modal-lg modal-dialog-centered"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Edit Schedule Email Sending Date</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>

            <div className="modal-body">
              <form
                className="form-control "
                onSubmit={handleUpdateScheduleData}
              >
                <div className="row">
                  <div
                    className="col-lg-6 overflow-auto"
                    style={{ maxHeight: "250px" }}
                  >
                    <h3>Scheduled Date List</h3>
                    {updateData ? (
                      <div className="card mb-3 scheduled-date-card">
                        <div className="card-body d-flex justify-content-between align-items-center">
                          <span className="scheduled-date">
                            <strong>Previous Scheduled Date:</strong>{" "}
                            {updateData?.scheduleDate}
                          </span>
                        </div>
                      </div>
                    ) : (
                      <p>No scheduled dates available.</p>
                    )}
                  </div>
                  <div className="col-lg-6">
                    <div className="">
                      <div className="mb-3">
                        <label className="form-label">Template Name</label>
                        <input
                          type="text"
                          className="form-control"
                          value={templateName}
                          onChange={(e) => setTemplateName(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="">
                      <div className="mb-3">
                        <label className="form-label">Edit Schedule Date</label>
                        <input
                          type="date"
                          required
                          className={`form-control ${
                            error ? "is-invalid" : ""
                          }`}
                          min={minDate}
                          value={date}
                          onChange={(e) => {
                            const selectedDate = e.target.value;
                            if (isDateDisabled(selectedDate)) {
                              setError(
                                "This date is not available for selection."
                              );
                            } else {
                              setError(""); // Clear the error if the date is valid
                            }
                            setDate(selectedDate);
                          }}
                        />
                        {error && (
                          <div className="invalid-feedback">{error}</div>
                        )}
                      </div>
                    </div>
                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-secondary"
                        data-bs-dismiss="modal"
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className="btn btn-primary ms-auto"
                        data-bs-dismiss="modal"
                      >
                        Update
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Emailmarketing;
